import { FC, memo } from 'react'
import { MemberTable } from './components/memberTable/memberTable'

export const GroupChatMemberListGrid: FC = memo(() => {
  return (
    <div className="h-full flex flex-col">
      <MemberTable />
    </div>
  )
})
